<template>
  <div class="aboutUs">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div class="content">
      <div class="logoInfo">
        <div class="logoImg" @click="showVc">
          <img src="../../../assets/img/logo.png" alt>
        </div>
        <div class="logoText">
          <p>QuantaData</p>
          <p>智慧建筑中无感通行的践行者</p>
        </div>
      </div>
      <div class="comIntroduce">
        <p>广州康塔科技有限公司，成立于2016年，是一家专注于为智慧楼宇提供智能无感通行服务的企业。</p>
        <p
          class
        >旗下品牌QuantaData提供了一套可定制化的综合出入口管理系统，实现门禁、闸机、人脸识别、目的层派梯等多模块综合集成管理，为物业或管理员提供了访客微信来访预约、楼宇统一授权、员工考勤、会议签到等多元化服务。</p>
        <hr>
        <p class="tel">
          <span />
          <a @click="callPhone">联系我们：400-837-8928</a>
        </p>
      </div>
    </div>
    <div class="footer">
      <p>广州康塔科技有限公司 版权所有</p>
      <p>Version 1.4.0 2016-{{ year }} QuantaData.All Rights Reserved.</p>
    </div>
  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, Dialog } from 'vant'

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      subHead: '关于我们',
      year: new Date().getFullYear(), // 当前年份
      lastClickTime: 0,
      count: 0

    }
  },
  methods: {
    callPhone() {
      window.location.href = 'tel://400-837-8928'
    },

    goBack() {
      this.$router.go(-1)
    },
    hasClass(obj, cls) {
      return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
    },
    addClass(obj, cls) {
      if (!this.hasClass(obj, cls)) obj.className += ' ' + cls
    },
    showVc() {
      const nowTime = new Date().getTime()
      // if (nowTime - this.lastClickTime < 3000) {

      // } else {
      //   this.count = 0
      // }
      this.count++
      this.lastClickTime = nowTime
      if (this.count >= 4) {
        const vconDom = document.getElementById('__vconsole')
        this.addClass(vconDom, 'vcshow')
        this.count = 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
.aboutUs {
  position: relative;
  .content {
    padding: 0rem 0.15rem;
    font-size: 0.14rem;
    .logoInfo {
      display: flex;
      padding: 0.14rem 0rem;
      .logoImg {
        width: 0.48rem;
        height: 0.48rem;
        background: #fff;
        text-align: center;
        padding: 0.07rem;
        margin-right: 0.16rem;
        border-radius: 4px;
        box-sizing: border-box;
        img {
          width: 0.34rem;
        }
      }
      .logoText {
        p:first-child {
          font-size: 0.18rem;
          color: #3b86ff;
          font-weight: bold;
        }
        p:last-child {
          color: rgba(51, 51, 51, 0.5);
        }
      }
    }
    .comIntroduce {
      background: #fff;
      padding: 0.1rem 0.23rem 0rem;
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      color: rgba(51, 51, 51, 0.7);
      p {
        line-height: 0.25rem;
      }
      p:not(:last-child) {
        margin-bottom: 0.25rem;
      }

      hr {
        height: 0px;
        border: 1px #cccccc dotted;
      }
      .tel {
        text-align: center;
        color: #3b86ff;
        height: 0.52rem;
        line-height: 0.52rem;
      }
    }
  }
  //样式要再调
  .footer {
    font-size: 0.1rem;
    color: rgba(51, 51, 51, 0.5);
    text-align: center;
    clear: both;
    display: block;
    margin: 0px auto;
    position: absolute;
    bottom: -2.1rem;
    width: 100%;
  }
}
</style>
